module.exports = __webpack_public_path__ + "static/media/why1.44b573d0.png";